var _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadelCourt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68756 14.8282C4.82112 16.39 6.50617 17.1807 7.54714 17.421V20.1082C7.54714 20.8769 8.17026 21.5 8.93891 21.5V21.5C9.70757 21.5 10.3307 20.8769 10.3307 20.1082V17.8845L10.9614 18.1498M3.68756 14.8282C2.98909 13.8659 2.5 12.6108 2.5 11.0112C2.5 5.76681 7.23662 4.23564 9.60493 5.21287L9.92226 5.47566M3.68756 14.8282H11.0527M11.0527 14.8282L10.3336 16.663C10.1048 17.2468 10.3834 17.9066 10.9614 18.1498V18.1498M11.0527 14.8282L11.4067 13.925C10.5815 13.1691 9.48094 11.7229 9.07434 9.98677M9.92226 5.47566C11.7036 2.56243 15.6949 1.95542 17.7249 2.93329C19.7548 3.58418 22.3917 5.94215 21.2041 10.1377C20.6009 12.2686 19.4586 13.4373 18.2352 14.074M9.92226 5.47566C9.46276 6.07331 8.64987 7.81223 9.07434 9.98677M9.07434 9.98677L18.2352 14.074M18.2352 14.074C16.4476 15.0043 14.4869 14.7988 13.7818 14.799L12.4802 17.5669C12.2121 18.137 11.5421 18.3942 10.9614 18.1498V18.1498",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.048,
    cy: 19.2197,
    rx: 2.36831,
    ry: 2.2802,
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadelCourt);
export default __webpack_public_path__ + "static/media/padel_court.327a4aad38a3762fd6469cde7d81f99b.svg";
export { ForwardRef as ReactComponent };